
export default {
  name: 'DefaultLayout',
  mounted() {
    this.$store.dispatch('fetchProductList', this.$api)
  },
}
